import type { ReviewUnit } from "../../../api/content/curationApi";
import type { DiscussionSubject } from "../../../api/content/discussionsApi";

/** What a unit's comments are about: its term, its item, or else the change set. */
export function unitSubject(unit: ReviewUnit, changeSetId: string): DiscussionSubject {
  if (unit.kind === "term" && unit.term !== null) {
    return { kind: "ontology_term", value: unit.term };
  }
  if (unit.kind === "item" || unit.kind === "affected") {
    return { kind: "item", value: unit.key.slice(unit.key.indexOf(":") + 1) };
  }
  return { kind: "change_set", value: changeSetId };
}
